import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import "./css/HeroGrid.css";
const HeroGrid = () => {
  return (
    <section className="grid-container container">
    <div className="grid-section">
      <div className="grid_1">
  <span>Joujo Safaris</span>
  <h2>Experience Africa, Your Way</h2>
</div>
<div className="grid_2">
  <p>
    Experience luxury lodges, thrilling Big Five safaris, and authentic cultural encounters with local communities — all seamlessly crafted into unforgettable adventures by Joujo Safaris.

  </p>
</div>
      </div>

      <div className="home-grid">
          
          <div className="grid-template">
            <LazyLoadImage
              alt="Masai Mara Safari"
              src={require('../assets/image/11.jpg')}
              effect="blur"
            />
            <LazyLoadImage
              src={require('../assets/image/12.jpg')}
              alt="Kenya Safari Sunset"
              effect="blur"
            />
            <LazyLoadImage
              src={require('../assets/image/13.jpg')}
              className='small-hid'
              alt="African Safari Adventure"
              effect="blur"
            />
          </div>
          <div>
            <h2>One Journey, Endless Possibilities</h2>
            <p>
  From sunrise balloon rides over the Masai Mara to serene beaches in Zanzibar, our tailored itineraries offer something for everyone. 
  With expert guides and carefully curated experiences, <b>your safari becomes more than a trip — it becomes a story</b>.
</p>
            <a href="/trips" className="btn-medium">Start Your Adventure</a>
          </div>
      </div>
    </section>
  );
};

export default HeroGrid;
